module.exports = __webpack_public_path__ + "static/media/research-icon-selected.f9884f59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/research-icon-selected.svg
// module id = 1928
// module chunks = 0